
const contactForm = {
  'contactMe.header': 'I cannot wait, contact me!',
  'contactMe.instructions': 'Please complete the below form so our representatives can get in contact with you.',
  'contactMe.name': 'Name',
  'contactMe.lastName': 'Last Name',
  'contactMe.email': 'Email (optional)',
  'contactMe.country': 'Country',
  'contactMe.whatsappNumber': 'WhatsApp Number',
  'contactMe.countryCode': 'Country code',
  'contactMe.language': 'Preferred Language',
  'contactMe.message': 'Message (optional)',
  'contactMe.submit': 'Submit',
  'contactMe.submitting': 'Submitting...',
  'contactMe.success.title': 'Thank you for reaching out!',
  'contactMe.success.message': 'Your information has been successfully submitted. A representative from The Club will get in contact with you shortly.',
  'contactMe.placeholders.name': 'Enter your name',
  'contactMe.placeholders.lastName': 'Enter your last name',
  'contactMe.placeholders.email': 'Enter your email',
  'contactMe.placeholders.country': 'Select your country',
  'contactMe.placeholders.countryCode': 'Code',
  'contactMe.placeholders.whatsappNumber': 'WhatsApp number',
  'contactMe.placeholders.language': 'Your preferred language',
  'contactMe.placeholders.message': 'Write your message here',
  'contactMe.errors.name': 'Name is required',
  'contactMe.errors.lastName': 'Last name is required',
  'contactMe.errors.email': 'Invalid email address',
  'contactMe.errors.country': 'Country is required',
  'contactMe.errors.countryCode': 'Country code is required',
  'contactMe.errors.whatsappNumber': 'WhatsApp number is required',
  'contactMe.errors.language': 'Language is required',
  'contactMe.errors.messageMaxLength': 'Message cannot exceed {max} characters',
  'contactMe.errors.submission': 'Form submission failed',
  'contactMe.errors.generic': 'Something went wrong. Please try again.',
  'contactMe.page.title': 'Start Earning Before Everyone Else',
};

export default contactForm;
